import { Action, combineReducers, configureStore } from '@reduxjs/toolkit';
import UILogger from 'common/utils/logger';
import { shallowEqual, TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import reducers from './reducers';

const combinedReducers = combineReducers({ ...reducers });

const reducerProxy = (state: any, action: Action) => {
  if (action.type === 'CLEAR_ALL_REDUX_STATES') {
    UILogger.log('Clearing all redux states....');
    return combinedReducers(undefined, action);
  }
  return combinedReducers(state, action);
};

export const store = configureStore({
  reducer: reducerProxy,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useObjectSelector: TypedUseSelectorHook<RootState> = (selector) => useSelector(selector, shallowEqual);
